import type { Tone } from '@/components/ui'
import type { PedagogyReviewSkipReason } from '@/services/pedagogyReviewQueueService'

// Цвет причины технического пропуска — одна таблица для технической очереди и «Анализа
// отсмотров», чтобы одна и та же причина везде была одного цвета и причины не сливались.
export const PEDAGOGY_SKIP_REASON_TONE: Record<PedagogyReviewSkipReason, Tone> = {
  recording_problem: 'warn',
  no_access: 'accent',
  no_camera: 'neutral',
  lesson_mismatch: 'info',
  queue_selection_error: 'danger',
}
